// Google Recaptcha validation for Salesforce Newsletter Signup
let newsletterSignup = document.getElementById("newsletter_signup");
if ( newsletterSignup ) {
  newsletterSignup.addEventListener("submit",function(evt)
    {

    var response = grecaptcha.getResponse(0);
    if(response.length == 0)
    {
      //reCaptcha not verified
      alert("Please complete the reCAPTCHA before submitting.");
      evt.preventDefault();
      return false;
    }
    //captcha verified
    //do the rest of your validations here

  });
}
